const config = {
    build_number: '616983',
    build_timestamp: '2026-10-14T21:01:53.112Z',
    build_commit: 'e8c2d7edf6de9ff4479f3fdc07d91b1cb8bf9edf',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
